import React, { useEffect } from 'react';
import { marked } from 'marked';
import Modal from './ui/Modal.jsx';
import { trackEvent } from '../firebase/config.js';
import { trackPixels } from '../analytics/pixels.js';

const EULAModal = ({ onAccept, eulaContent }) => {
    useEffect(() => {
        try { trackEvent('onboarding_step', { step: 'eula_modal' }); } catch (_) {}
        try { trackPixels('PageView', { page: 'eula_modal' }); } catch (_) {}
    }, []);
    return (
        <Modal title="Terms and Conditions" onClose={onAccept} size="3xl" footer={
            <div className="flex justify-center">
                <button onClick={onAccept} className="inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm text-white bg-gradient-to-r from-teal-600 to-emerald-600">I Agree</button>
            </div>
        }>
            <div className="prose prose-invert max-w-none [&>*]:text-left prose-headings:text-left prose-p:text-left prose-p:text-sm prose-p:text-slate-300 prose-li:text-sm prose-li:text-slate-300 prose-h2:text-sm prose-h2:uppercase prose-h2:tracking-wider prose-h2:text-slate-200 prose-strong:text-slate-100" style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: marked(eulaContent || '') }} />
        </Modal>
    );
};

export default EULAModal;


